export const colors = [
  '#FEDF00',
  '#FF3061',
  "#C46FDF",
  "#4494FA",
  "#5DC15D",
  "#FF9300"
];
